import { useQuery, queryOptions } from '@tanstack/react-query';
import { authClient } from '@/features/auth/lib/auth-client';

const sessionQueryKey = ['session'];

const sessionQueryFn = async () => {
  const { data } = await authClient.getSession();
  return data;
};

export const sessionQueryOptions = queryOptions({
  queryKey: sessionQueryKey,
  queryFn: sessionQueryFn,
  staleTime: 5 * 60 * 1000,
});

/**
 * Returns the current session. Disabled during SSR so the server and client
 * initial render both produce `isPending: true` — avoiding hydration mismatches.
 * Callers should show a stable placeholder while `isPending` is true.
 */
export function useSession() {
  const { data: session, isPending } = useQuery({
    ...sessionQueryOptions,
    enabled: typeof window !== 'undefined',
  });
  const isAuthenticated = !isPending && !!session?.user;
  return { session, isAuthenticated, isPending };
}
